function toggleCart(doClose = false) {
  const drawer = document.querySelector('#cart-drawer')
  if (!drawer.classList.contains('is-drawer-open') && !doClose) {
    drawer.classList.add('is-drawer-open')
    drawer.classList.add('is-open')
    document.body.style.overflow = 'hidden'
    document.querySelectorAll(['[data-animation="cart-items-fade"]']).forEach(item => {
      item.classList.add('is-animated')
    }, 50)
    document.querySelectorAll('#addToCart').forEach(item => {
      item.classList.remove('loading')
    })
  } else {
    drawer.classList.add('is-closing')
    document.body.style.overflow = 'unset'
    document.querySelector('body').classList.remove('upcartPopupShow')
    document.querySelectorAll(['[data-animation="cart-items-fade"]']).forEach(item => {
      item.classList.remove('is-animated')
    }, 50)
    setTimeout(() => {
      drawer.classList.remove('is-drawer-open')
      drawer.classList.remove('is-closing')
      drawer.classList.remove('is-open')
    }, 300)
  }
}

let upgradeFromVariantId = ''
let upgradeBlock = null

function bodyOverflow() {
  setTimeout(() => {
    document.body.style.overflow = 'hidden'
  }, 500)
  window.removeEventListener('transitionend', bodyOverflow)
}


function fetchCart() {
  let section_id = ''
  document.querySelectorAll('.shopify-section-group-header-group').forEach(item => {
    if (item.getAttribute('id').includes('cart-drawer')) {
      section_id = item.getAttribute('id').replace('shopify-section-', '')
    }
  })

  let pathname = location.pathname.split('/')[1]
  if (pathname && pathname !== 'products') {
    pathname = '/' + pathname
  } else {
    pathname = ''
  }
  fetch(`${pathname}/cart?section_id=${section_id}`)
    .then((response) => response.text())
    .then((response) => {
      document.querySelector('#cart-drawer').classList.remove('is-loading')

      document.querySelector('#cart-drawer').querySelector('.drawer__inner').innerHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.drawer__inner').innerHTML

      console.log('fetchCart toggle')

      setTimeout(() => {
        toggleCart()
      }, 0)

      document.querySelector('checkout-btn')?.classList.remove('free-gift-loading')
    })

  fetch(`${pathname}/cart.js`)
    .then((response) => response.json())
    .then((response) => {
      document.querySelectorAll('cart-counter')
        .forEach(item => {
          let count = response.item_count
          const protectionId = Number(item.getAttribute('data-order-protection-id'))

          for (const item of response.items) {
            if (item.product_id === protectionId) {
              count--
            }
          }
          item.updateCount(count)
        })
    })
}


document.addEventListener('DOMContentLoaded', () => {
  let adding = false

  document.addEventListener('theme:product:add', fetchCart)

  document.querySelector('#cart-drawer .drawer__underlay').addEventListener('click', () => {
    toggleCart(true)
  })

  console.log('cart-toggle', document.querySelectorAll(['[data-cart-toggle]', '#cart-icon-bubble']))
  document.querySelectorAll(['[data-cart-toggle]', '#cart-icon-bubble']).forEach(item => item.addEventListener('click', (event) => {
    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()

    toggleCart()
  }))


  if (!customElements.get('order-protection')) {
    customElements.define('order-protection', class OrderProtection extends HTMLElement {
      constructor() {
        super();
        this.btn = this.querySelector('a')
        this.cartJson = JSON.parse(this.querySelector('#cart-json').innerHTML)
        this.productId = Number(this.getAttribute('data-id'))

        this.querySelector('.top-text .price').innerHTML = `${this.querySelector('.top-text .price').getAttribute('data-symbol')}${Number(this.querySelector('.top-text .price').getAttribute('data-price') * window.Shopify.currency.rate / 100).toFixed(2)}`

        this.initializeProtection()

        this.btn.addEventListener('click', () => this.handleButtonClick())
      }

      initializeProtection() {
        const hasManuallyToggled = localStorage.getItem(`protection_toggled_${this.productId}`)
        const productExists = this.cartJson.items.some(item => item.product_id === this.productId)

        if (productExists) {
          if (this.getAttribute('data-enabled') === 'true') {
            this.btn.classList.add('active')
          } else {
            CartJS.removeItemById(this.btn.getAttribute('data-id'))
          }
        } else if (!hasManuallyToggled && this.getAttribute('data-enabled') === 'true') {
          // Auto-add protection if not manually toggled before and enabled by default
          this.btn.classList.add('active')
          CartJS.addItem(this.btn.getAttribute('data-id'))
        }
      }

      handleButtonClick() {
        if (window.noCartRefresh) {
          return
        }

        this.btn.classList.toggle('active')
        document.querySelector('checkout-btn').classList.add('free-gift-loading')
        window.noCartRefresh = true

        // Mark as manually toggled
        localStorage.setItem(`protection_toggled_${this.productId}`, 'true')

        if (this.btn.classList.contains('active')) {
          CartJS.addItem(this.btn.getAttribute('data-id'))
        } else {
          CartJS.removeItemById(this.btn.getAttribute('data-id'))
        }
      }
    })
  }

})

if (!customElements.get('upsell-block')) {
  customElements.define('upsell-block', class UpsellBlock extends HTMLElement {
    constructor() {
      super();

      this.querySelector('.up-wrap-out .closeit')?.addEventListener('click', (event) => {
        document.querySelector('.activeupsell').classList.remove('activeupsell')
        document.body.style.overflow = ''
      })

      this.querySelectorAll(['.up-wrap-out .open-cart', '.up-wrap-out .closeit']).forEach(item => item.addEventListener('click', (event) => {
        document.querySelector('.activeupsell')?.classList.remove('activeupsell')
        document.body.style.overflow = ''
        fetchCart()
      }))

      this.querySelector('.up-wrap-out .btns.cart')?.addEventListener('click', (event) => {
        CartJS.removeItemById(upgradeFromVariantId)
        CartJS.addItem(event.target.closest('.cart-btn').getAttribute('data-upsell-id'), 1)
      })

    }
  })
}

if (!customElements.get('cart-item')) {
  customElements.define('cart-item', class CartItem extends HTMLElement {
    constructor() {
      super();


      const productId = this.getAttribute('data-product-id')


      document.querySelectorAll('free-gift-product').forEach(item => {
        const freeGiftProduct = item.querySelector('#free-products') ? JSON.parse(item.querySelector('#free-products')?.innerHTML) : null
        if (freeGiftProduct?.find(item => item.id === Number(productId)) && Number(this.getAttribute('data-final-price')) === 0) {
          this.querySelector('.cart_item_remove').style.display = 'none'
          this.querySelector('.cart__quantity').style.display = 'none'
        }
      })

      this.querySelector('.cart_item_remove').addEventListener('click', (event) => {
        // event.target.classList.add('free-gift-loading')
        document.querySelector('cart-drawer').classList.add('is-loading')

        const btn = event.target.closest('.cart_item_remove')

        CartJS.removeItem(btn.getAttribute('data-line'))
      })

      this.querySelector('.cart__quantity-minus').addEventListener('click', () => {
        this.querySelector('input').stepDown()
        this.updateQuantity()
      })
      this.querySelector('.cart__quantity-plus').addEventListener('click', () => {
        this.querySelector('input').stepUp()
        this.updateQuantity()
      })

    }

    timeout = null

    updateQuantity() {
      if (this.timeout) {
        return
      }

      this.timeout = setTimeout(() => {
        // this.querySelector('.cart_item_remove').classList.add('free-gift-loading')
        document.querySelector('cart-drawer').classList.add('is-loading')
        CartJS.updateItem(this.querySelector('.cart_item_remove').getAttribute('data-line'), this.querySelector('input').value)
        this.timeout = null
      }, 300)
    }
  })
}

if (!customElements.get('quick-add')) {
  customElements.define('quick-add', class QuickAdd extends HTMLElement {
    constructor() {
      super();

      this?.addEventListener('click', event => {
        if (this.adding) {
          return
        }

        this.classList.add('loading')
        event.preventDefault()
        event.stopPropagation()

        const formData = new FormData(event.target.closest('form'))

        if (this.getAttribute('data-confetti') === 'true') {
          triggerConfetti(this)
        }

        this.adding = true
        fetch('/cart/add', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript',
          },
          body: formData,
        })
          .then((response) => {
            fetchCart()
            this.classList.remove('loading')
            this.adding = false
          })
          .catch((error) => {
            console.error('Error adding item to cart:', error)
            this.classList.remove('loading')
            this.adding = false
          })
      })
    }

    adding = false;

    updateBtn() {

      this.querySelector('button').classList.add('is-added')
      this.querySelector('button').addEventListener('transitionend', this.resetButton.bind(this))

      if (window.displayUpgrade) {
        upgradeBlock.classList.add('activeupsell')
        window.addEventListener('transitionend', bodyOverflow)
        window.scrollTo(0, 0)
        window.displayUpgrade = false
      }

      $(document).off('cart.requestComplete', this.updateBtn.bind(this))
    }

    resetButton() {
      this.querySelector('button').classList.remove('is-loading')
      this.querySelector('button').classList.remove('is-added')
      this.querySelector('button').removeEventListener('transitionend', this.resetButton)
    }
  })
}

if (!customElements.get('cart-header')) {
  customElements.define('cart-header', class CartHeader extends HTMLElement {
    constructor() {
      super();

      this.querySelector('.drawer__close').addEventListener('click', event => {
        toggleCart()
      })
    }
  })
}

if (!customElements.get('cart-counter')) {
  customElements.define('cart-counter', class CartHeader extends HTMLElement {
    constructor() {
      super();

      if (document.querySelector('order-protection')) {
        this.setAttribute('data-order-protection-id', document.querySelector('order-protection').getAttribute('data-id'))
      }

      if (document.querySelector('#cart-json')) {
        this.cartJson = JSON.parse(document.querySelector('#cart-json').innerHTML)

        let currentCount = this.cartJson.item_count

        const protectionId = Number(this.getAttribute('data-order-protection-id'))

        for (const item of this.cartJson.items) {
          if (item.product_id === protectionId) {
            currentCount--
          }
        }

        this.updateCount(currentCount)
      }
    }

    cartJson = null

    updateCount(count) {
      if (count === 0) {
        this.style.display = 'none'
        return
      }

      this.innerHTML = count
      this.style.display = 'flex'
    }
  })
}



